export interface NovaAgentSummary {
	id: string;
	title: string;
	// Optional: the Studio requires a Description on creation, but a picker row must still cope
	// with one missing rather than assume it's always present.
	description?: string;
	category: string;
	isDefault: boolean;
}

// NovaAgentPicker.test.tsx's missing-description test temporarily pushes/pops a fixture onto
// this exact array (inside a try/finally) rather than mocking the module, so every other test in
// that file keeps exercising the real catalogue — don't reorder or freeze this without updating
// that test.
export const MOCK_AGENTS: NovaAgentSummary[] = [
	{
		id: 'general',
		title: 'General',
		description: 'Reads the task and its thread, works out what is needed, and drafts a response for your review.',
		category: 'Default',
		isDefault: true,
	},
	{
		id: 'faq',
		title: 'FAQ writer',
		description: 'Turns task outcomes into client-facing FAQ entries in your brand voice.',
		category: 'Marketing',
		isDefault: false,
	},
	{
		id: 'blog',
		title: 'Blog / article writer',
		description: 'Long-form drafts from a task brief, structured for your content pipeline.',
		category: 'Marketing',
		isDefault: false,
	},
	{
		id: 'email',
		title: 'Marketing email writer',
		description: "Drafts campaign emails in the client's voice.",
		category: 'Marketing',
		isDefault: false,
	},
	{
		id: 'release',
		title: 'Release notes writer',
		description: 'Compiles release notes from completed tasks in the sprint.',
		category: 'Product',
		isDefault: false,
	},
	{
		id: 'status',
		title: 'Status summariser',
		description: 'Writes client-ready status updates from task activity, progress and time entries.',
		category: 'Delivery',
		isDefault: false,
	},
	{
		id: 'scope',
		title: 'Scoping helper',
		description: "Breaks a request into estimated subtasks, following your team's past breakdowns.",
		category: 'Delivery',
		isDefault: false,
	},
	{
		id: 'translate',
		title: 'Translator',
		description: 'Translates task content and briefs into another language.',
		category: 'Localisation',
		isDefault: false,
	},
];
